/*
 * Spill That scroll zoom.
 * Media inside [data-spill-zoom] starts slightly zoomed in and settles to 1:1
 * as the box travels from the bottom of the screen to the top. Scale follows
 * scroll position (no tween), the CSS transition adds the soft settle.
 * Skipped entirely when the visitor prefers reduced motion.
 */
(function () {
  if (window.SpillScrollZoom) return;

  var MAX_ZOOM = 0.12;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = [];
  var ticking = false;
  var observer = null;

  function progress(el) {
    var rect = el.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    var seen = (viewport - rect.top) / (viewport + rect.height);
    return Math.min(1, Math.max(0, seen));
  }

  function update(el) {
    var remaining = 1 - progress(el);
    // Ease-out: most of the zoom settles in the first half of the travel.
    el.style.setProperty('--spill-zoom', (1 + MAX_ZOOM * remaining * remaining).toFixed(4));
  }

  function updateVisible() {
    ticking = false;
    for (var i = 0; i < items.length; i++) {
      if (items[i].visible) update(items[i].el);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateVisible);
  }

  function register(el) {
    if (el.spillZoomRegistered) return;
    el.spillZoomRegistered = true;
    var item = { el: el, visible: !observer };
    items.push(item);
    update(el);
    if (observer) observer.observe(el);
  }

  function init(root) {
    if (reduceMotion) return;
    var els = (root || document).querySelectorAll('[data-spill-zoom]');
    for (var i = 0; i < els.length; i++) register(els[i]);
  }

  if (!reduceMotion) {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            for (var i = 0; i < items.length; i++) {
              if (items[i].el !== entry.target) continue;
              items[i].visible = entry.isIntersecting;
              if (entry.isIntersecting) update(entry.target);
            }
          });
        },
        { rootMargin: '15% 0px' }
      );
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', updateVisible);
  }

  window.SpillScrollZoom = { init: init, refresh: updateVisible };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }
})();
